"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivePublicHolidays = void 0;
const dayjs = require("dayjs");
const getActivePublicHolidays = (date, public_holidays) => {
    if (!public_holidays)
        return [];
    const active_holidays = public_holidays.filter((holiday) => {
        if (dayjs(date).isBefore(dayjs(holiday.start_date)))
            return false;
        if (dayjs(date).isAfter(dayjs(holiday.end_date)))
            return false;
        return true;
    });
    return active_holidays;
};
exports.getActivePublicHolidays = getActivePublicHolidays;
